import React, { Component, createRef } from 'react'
import PropTypes from 'prop-types'
import styles from './DropDownSelect.module.css'
// import Icon from '../Icon'

export default class DropDownSelect extends Component {
  static propTypes = {
    label: PropTypes.string,
    onChange: PropTypes.func,
    options: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.number
    })),
    value: PropTypes.number
  }

  constructor (props) {
    super(props)
    this.select = createRef()

    this._handleChange = this._handleChange.bind(this)
  }

  resetSelect() {
    this.select.current.value = ''
    this.props.onChange(parseInt(this.select.current.value))
  }

  _renderOptions () {
    const { options } = this.props

    const optionsWithEmptyOption = [
      { label: 'Välj konto', value: '' },
      ...options
    ]

    return optionsWithEmptyOption.map((option, i) => (
      <option
        key={`DropDownSelect-option-${i}`}
        onClick={this._handleChange.bind(this, option.value, option.label)}
        value={option.value}>
        {option.label}
      </option>
    ))
  }

  _handleChange (event) {
    this.props.onChange(parseInt(event.target.value))
  }

  render () {
    return (
      <div className={styles['dropdown-select-container']}>
        {this.props.label && <h2>{this.props.label}</h2>}
        <div className={styles.wrapper}>
          <select
            onChange={this._handleChange}
            ref={this.select}
            className={styles.select}
            value={this.props.value ? this.props.value : ''}>
            {this._renderOptions()}
          </select>
          <div className={styles.select__arrow} />
        </div>
      </div>
    )
  }
}
